
import React from 'react';

const FacilitiesSection: React.FC = () => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-3xl font-bold text-gray-900 mb-6">Visit Our Facilities</h2>
            <p className="text-lg text-gray-600 mb-8">
              Experience our state-of-the-art training facilities firsthand. See where your team 
              will learn and grow with our modern equipment and comfortable learning environments.
            </p>

            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-computer-line text-green-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900">Modern Training Rooms</h3>
                  <p className="text-gray-600">Fully equipped classrooms with latest technology and comfortable seating</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-tools-line text-green-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900">Practical Workshop Areas</h3>
                  <p className="text-gray-600">Hands-on learning spaces for skills development and practical training</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-wifi-line text-green-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900">High-Speed Internet</h3>
                  <p className="text-gray-600">Reliable connectivity for online learning and digital resources</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-restaurant-line text-green-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900">Catering Facilities</h3>
                  <p className="text-gray-600">On-site refreshment areas and catering options for extended training sessions</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-shield-check-line text-green-600 text-xl"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-gray-900">Safe Environment</h3>
                  <p className="text-gray-600">Secure premises with health and safety protocols in place</p>
                </div>
              </div>
            </div>

            <div className="mt-8">
              <button className="bg-green-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-green-700 transition-colors whitespace-nowrap">
                Schedule a Facility Visit
              </button>
            </div>
          </div>

          <div className="relative">
            <div className="rounded-lg overflow-hidden shadow-xl">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20professional%20training%20facility%20with%20bright%20classrooms%2C%20comfortable%20seating%20arrangements%2C%20interactive%20whiteboards%2C%20computers%2C%20and%20natural%20lighting.%20Clean%20contemporary%20design%20with%20people%20learning%20in%20a%20corporate%20training%20environment&width=600&height=400&seq=facilities-visit&orientation=landscape"
                alt="Sylman Academy Training Facilities"
                className="w-full h-96 object-cover object-top"
              />
            </div>
            
            <div className="absolute -bottom-6 -left-6 bg-white rounded-lg shadow-lg p-6 max-w-xs">
              <div className="flex items-center space-x-3">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
                  <i className="ri-award-line text-green-600 text-xl"></i>
                </div>
                <div>
                  <p className="font-semibold text-gray-900">QCTO Accredited</p>
                  <p className="text-sm text-gray-600">Certified training facilities</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FacilitiesSection;
